import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import ModalFlexible from 'saur_ui_library/src/Organisms/ModalFlexible/ModalFlexible';
import React, { FC, useEffect, useState } from "react";
import styled, { createGlobalStyle } from "styled-components";
import Diagperm from "../common/Icon/diagperm.png";
import CpoDown from "../common/Icon/CpoDown.svg";
import CpoDenied from "../common/Icon/CpoDenied.svg";
import CpoNotFound from "../common/Icon/CpoNotFound.svg";
type CpoErrorProps = {
  statusCode: any;
};

const CpoError: FC<CpoErrorProps> = (props) => {
  const [isVisible, setIsVisible] = useState<any>(false);
  const [message, setMessage] = useState<any>("");
  const [image, setImage] = useState<any>(Diagperm);

  useEffect(() => {
    //if status code is undefined
    if (props.statusCode === undefined || props.statusCode === 400) {
      setMessage("Nous avons rencontrez un problème. Veuillez reessayer ");
      setImage(CpoDown);
      setIsVisible(true);
    } else {
      if (props.statusCode === 200) {
        setIsVisible(false);
      } else if (props.statusCode === 403) {
        setMessage("Accès refusé. Veuillez contactez votre administrateur ");
        setImage(CpoDenied);
        setIsVisible(true);
      } else if (props.statusCode === 404) {
        setMessage("Aucun Cpo trouvé.");
        setImage(CpoNotFound);
        setIsVisible(true);
      }
    }
  }, [props.statusCode]);

  const popupContent = () => (
    <Container className='contentContainer' style={{ width: 450, height: 10 }}>
      <Container className=''>
        <img
          className='cpoError-logo'
          id='img-cpo-error'
          alt='erreur'
          src={image}
        ></img>
        <Word
          value={message}
          textStyle='normalReg'
          variant='p'
          automatedTestId='id-message'
          className='cpoError-message'
        />
        <StyledSectionButton>
          <Button
            className='cpo-btn'
            mode='plain'
            onClick={() => {
              setIsVisible(!isVisible);
            }}
          >
            <Word variant='span' textStyle='normalBold' value='OK' />
          </Button>
        </StyledSectionButton>
      </Container>
    </Container>
  );
  
  return (
    <Container className="cpoErrorContainer">
      <Styles />
      <ModalFlexible
        className="error-modal"
        showHeader
        title="Donnée inexistante"
        toggleModal={() => {
          setIsVisible(!isVisible);
        }}
        visible={isVisible}
        desktopContent={popupContent}
      />
    </Container>
  );
};

const StyledSectionButton = styled(Container)`
  flex-direction: row;
  justify-content: space-around;
`;
const Styles = createGlobalStyle`
.sds-reset-style{
  .cpo-btn{
    margin-left: auto;
    margin-right: auto;
  }
.cpoErrorContainer{
  margin-left: auto;
  margin-right: auto;
  z-index:200;
  .sds-container.modal-flex-desktop-position{
    height: 350px;
  }
  .sds-container.modal-flex-desktop-position .modal-flex-desktop-content .modal-flex-desktop-header {
    align-items: flex-end !important;
    flex-direction: column;
    padding: 0px;
  }
  .message-btn, .cpoError-message{
    align-self: center;
  }
}
.contentContainer{
  margin-left: auto;
  margin-right: auto;  
}
.errorMessage{
  margin-left: auto;
  margin-right: auto; 
}
}
 
`;
export default CpoError;
